import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Heading from '@atlaskit/heading';
import { Stack, xcss } from '@atlaskit/primitives';
import { useSelectedWorkspace } from '../../../Flow/ConsentContextProvider';
import PermissionCard from '../../shared/agent-consent/PermissionCard/PermissionCard';
import { a2aPermissionMessages } from './messages';

const stackStyle = xcss({ width: '100%', maxWidth: '100%' });

/**
 * Static permission card for the A2A consent flow.
 * Displays a single, non-editable "Rovo Chat" permission.
 */
const A2APermission: FunctionComponent = () => {
  const { selectedWorkspace } = useSelectedWorkspace();

  if (!selectedWorkspace) return null;

  return (
    <Stack xcss={stackStyle} space="space.200">
      <Heading size="small">
        <FormattedMessage {...a2aPermissionMessages.sectionTitle} />
      </Heading>
      <PermissionCard
        title={<FormattedMessage {...a2aPermissionMessages.rovoChatTitle} />}
        description={<FormattedMessage {...a2aPermissionMessages.rovoChatDescription} />}
      />
    </Stack>
  );
};

export default A2APermission;
